"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _utils = require("../../utils");
var _classnames = _interopRequireDefault(require("classnames"));
var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));
var _useDebounce = require("use-debounce");
var _excluded = ["className", "name", "email", "emailCls", "avater", "onClose", "onSelect", "iconCls", "iconSize"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function RecipientBadge(_ref, ref) {
  var className = _ref.className,
    name = _ref.name,
    email = _ref.email,
    emailCls = _ref.emailCls,
    avater = _ref.avater,
    onClose = _ref.onClose,
    onSelect = _ref.onSelect,
    iconCls = _ref.iconCls,
    iconSize = _ref.iconSize,
    otherProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var isValidatedEmail = (0, _react.useMemo)(function () {
    return (0, _utils.isEmail)(email);
  }, [email]);
  var _useDebouncedCallback = (0, _useDebounce.useDebouncedCallback)(onSelect, 600),
    _useDebouncedCallback2 = (0, _slicedToArray2["default"])(_useDebouncedCallback, 2),
    onRecipientHoverIn = _useDebouncedCallback2[0],
    cancelDebounce = _useDebouncedCallback2[1];
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, otherProps, {
    ref: ref,
    className: (0, _classnames["default"])('m-1 pl-4 pr-2 h-8 text-sm shadow rounded-full inline-flex flex-no-wrap items-center  select-none', isValidatedEmail ? 'bg-card dark:bg-secondary' : 'bg-red text-white', className),
    onMouseEnter: isValidatedEmail ? onRecipientHoverIn : null,
    onMouseLeave: isValidatedEmail ? cancelDebounce : null
  }), avater, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('max-w-xs ml-2 truncate cursor-pointer', emailCls, {
      'text-dark': isValidatedEmail
    })
  }, !!name ? name : email), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('ml-3 cursor-pointer flex', {
      'hover:text-gray-light': !isValidatedEmail,
      'hover:text-dark': isValidatedEmail,
      'text-gray-medium': isValidatedEmail,
      'text-white': !isValidatedEmail
    }, iconCls),
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();
      onClose();
    }
  }, /*#__PURE__*/_react["default"].createElement(_Close["default"], {
    style: {
      fontSize: iconSize || 16
    }
  })));
}
var _default = exports["default"] = /*#__PURE__*/(0, _react.forwardRef)(RecipientBadge);
//# sourceMappingURL=RecipientBadge.js.map